// extracted by mini-css-extract-plugin
export default {"profilesWrapper":"styles_profilesWrapper__KG0cT","emptyValue":"styles_emptyValue__BTPPb"};